import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useMemo } from 'react';

const useBreakpoint = () => {
  const theme = useTheme();
  const breakpoints = theme.breakpoints;

  const isXs = useMediaQuery(breakpoints.only('xs'));
  const isSm = useMediaQuery(breakpoints.only('sm'));
  const isMd = useMediaQuery(breakpoints.only('md'));
  const isLg = useMediaQuery(breakpoints.only('lg'));
  const isXl = useMediaQuery(breakpoints.only('xl'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const currentBreakpoint = useMemo(() => {
    if (isXl) return 'xl';
    if (isLg) return 'lg';
    if (isMd) return 'md';
    if (isSm) return 'sm';
    return 'xs';
  }, [isXs, isSm, isMd, isLg, isXl]);

  return useMemo(() => ({ currentBreakpoint, isMobile }), [currentBreakpoint, isMobile]);
};

export default useBreakpoint;
